<sol-dropdown class="permission-select"
              *ngIf="params"
              [selection]="{ value: params.data.permission }"
              (selectionChange)="onValueChange($event)"
              [options]="options"
              [optionsValue]="'value'"
              [optionsLabel]="'value'"
              [optionTemplate]="permissionOption"
              [selectedOptionTemplate]="selectedPermission"
              [applyTemplateToAllOptions]="true">
</sol-dropdown>

<ng-template #permissionOption let-optionScope="optionScope">
    @if (optionScope.id === owner) {
    <svg class="icon-16 fill-cxone mr-1 mb-1">
        <use href="../App_Themes/CXone/icons/user-owner.svg#user-owner"></use>
    </svg>
    <span>{{ownerLabel}}</span>
    } @else if (optionScope.id === view) {
    <span>{{viewOnlyLabel}}</span>
    }
</ng-template>

<ng-template #selectedPermission let-placeholderValue="placeholderValue">
    @if (placeholderValue.option.value === owner) {
    <svg class="icon-16 fill-cxone mr-1 mb-1">
        <use href="../App_Themes/CXone/icons/user-owner.svg#user-owner"></use>
    </svg>
    <span>{{ownerLabel}}</span>
    } @else if (placeholderValue.option.value === view) {
    <span>{{viewOnlyLabel}}</span>
    }
</ng-template>
